import { DeterministicView } from '@bingads-webui/deterministic-view';
import template from './account-information-view-template.pug';

export const getAccountInformationView = ({ i18n }) => {
  if (!i18n) {
    return {};
  }
  /**
   * Class representing an account information view for HotelCenter
   * @extends View
   */
  class AccountInformationView extends DeterministicView {
    /**
    * Initializes AccountInformationView
    * Creates model and give default parameter for account information.
    * @returns { undefined }
    */
    initialize() {
      this.i18n = i18n;
    }

    get template() {
      return template;
    }
  }

  return {
    AccountInformationView,
  };
};

